module.exports = __webpack_public_path__ + "static/media/placeholder.64430f35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/placeholder.png
// module id = 562
// module chunks = 0